var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 40,
    viewBox: "0 0 44 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 39,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 39,
    rx: 3.5,
    stroke: "#E5E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9333 11.7167L18.3249 16.3333C18.0166 16.6417 17.8416 17.0667 17.8416 17.5083V25.8333C17.8416 26.75 18.5916 27.5 19.5083 27.5H26.9999C27.6666 27.5 28.2666 27.1 28.5249 26.4917L31.2416 20.15C31.9499 18.5 30.7416 16.6667 28.9499 16.6667H24.2416L25.0333 12.85C25.1166 12.4333 24.9916 12.0083 24.6916 11.7083C24.1999 11.225 23.4166 11.225 22.9333 11.7167ZM14.4999 27.5C15.4166 27.5 16.1666 26.75 16.1666 25.8333V19.1667C16.1666 18.25 15.4166 17.5 14.4999 17.5C13.5833 17.5 12.8333 18.25 12.8333 19.1667V25.8333C12.8333 26.75 13.5833 27.5 14.4999 27.5Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.76843243af42290ea5410c01101ae24f.svg";
export { ForwardRef as ReactComponent };